import request from '@/utils/request'

// 获取可发送的小程序列表
export function miniprogramList(params) {
  return request({
    url: '/spWorkWechat/upTool/miniprogramList',
    method: 'get',
    params
  })
}
